export default __webpack_public_path__ + "static/media/create.fcbc47b9.svg";